import { component$ } from "@builder.io/qwik";
import { LuTarget } from "@qwikest/icons/lucide";
import { Badge } from "./badge";

export const ScoreBadge = component$<{ score: number }>(({ score }) => (
  <div class="absolute bottom-0 flex w-full justify-center">
    <Badge class="absolute -bottom-2 mx-auto" variant="overlay" size="lg">
      <LuTarget />
      {score}
    </Badge>
  </div>
));
